import Vue from 'vue'
import store from '@/store'

Vue.directive('permission', {
  inserted(el, binding, vnode) {
    const { value } = binding
    if (!value) return

    // 任务1(0908)：用户管理页豁免 ERP 只读——用户为 WMS 内部账号，与 ERP 主数据治理语义不同，
    // 无论工厂是否连接 ERP，管理员都应能增删改用户（仅角色权限约束）
    const vm = vnode && vnode.context
    const routePath = (vm && vm.$route && vm.$route.path) || ''
    if (routePath.includes('/user')) {
      if (!store.getters.hasPermission(value)) {
        el.parentNode && el.parentNode.removeChild(el)
      }
      return
    }

    // 1. 工厂 ERP 权限：增删改按钮在 ERP 模式下隐藏（主数据由 ERP 统一维护）
    const editButtons = ['button:add', 'button:edit', 'button:delete', 'button:import']
    if (editButtons.includes(value)) {
      // 从 localStorage 读取（切换工厂后刷新时最可靠），Vuex 作为补充
      const erpType = localStorage.getItem('erpType') || 'NONE'
      if (erpType !== 'NONE') {
        el.parentNode && el.parentNode.removeChild(el)
        return
      }
      // NONE 模式下不做 ERP 限制，继续检查角色权限
    }

    // 2. 原有角色权限检查
    const hasPerm = store.getters.hasPermission(value)
    if (!hasPerm) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
})
